import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/how-it-works/components/BusinessFlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/how-it-works/components/ConsentModel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/how-it-works/components/DataPrivacy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/how-it-works/components/HowItWorksHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/app/how-it-works/components/PetOwnerFlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998fb9ef782d50014d47ea7/petfob/src/components/ui/AppLogo.tsx");
